import { Card, Code, HStack, Spacer, Text } from "@chakra-ui/react";
import * as React from "react";
import { LuCopy } from "react-icons/lu";
import { useParams } from "react-router-dom";

import { getScript } from "../../api/workspace";
import { Button } from "../../components/button";
import PageBody from "../../components/page-body";
import SectionBody from "../../components/section-body";
import SectionHeader from "../../components/section-header";
import { toaster } from "../../components/toaster";

export default function PixelPage() {
  const { workspace } = useParams();
  const [script, setScript] = React.useState("");
  const loadScript = React.useCallback(async () => {
    let script = await getScript(workspace);
    script = script
      .split("\n")
      .map((line) => "  " + line)
      .join("\n")
      .trimEnd();
    setScript(`<script>\n${script}\n</script>`);
  }, [workspace]);
  const copyScript = React.useCallback(() => {
    navigator.clipboard.writeText(script);
    toaster.create({
      type: "success",
      title: "Copied",
      description: "The code has been copied to your clipboard.",
    });
  }, [script]);
  React.useEffect(() => {
    loadScript();
  }, [loadScript]);

  return (
    <PageBody>
      <SectionHeader
        title="Pixel"
        description="Use this pixel to capture pre-conversion activity"
      />
      <Card.Root variant="elevated" maxW="xl">
        <Card.Body>
          <SectionBody>
            <HStack>
              <Text>
                Paste this code in the{" "}
                <Code colorPalette="gray">&lt;head&gt;</Code> section of your
                website.
              </Text>
              <Spacer />
              <Button
                colorPalette="gray"
                onClick={copyScript}
                size="sm"
                variant="outline"
              >
                <LuCopy /> Copy
              </Button>
            </HStack>
            <Code
              asChild
              colorPalette="gray"
              overflow="scroll"
              p="2"
              variant="surface"
            >
              <pre>{script}</pre>
            </Code>
          </SectionBody>
        </Card.Body>
      </Card.Root>
    </PageBody>
  );
}
